const ContainerStyle = {
  'z-index': 100
};

export default ContainerStyle;
